import React, { memo } from 'react'
import { BINARY_CHOICE } from 'apps/carrier/constants/insurance'
import { prefixIds } from 'apps/carrier/utils/insurance'
import InsuranceDialogSection from './InsuranceDialogSection'

const holderOptions = prefixIds(BINARY_CHOICE, 'cargoInsurance-isTransfixAsHolder')
const lossPayeeOptions = prefixIds(BINARY_CHOICE, 'cargoInsurance-isTransfixAsLossPayee')

interface ICargoCoverageLiabilityProps {
  liabilityAmount?: string
  expirationDate?: string
  hasReeferBreakdown?: boolean
  hasUnattendedVehicleCoverage?: boolean
  hasTheftCoverage?: boolean
  isTransfixAsHolder?: boolean
  isTransfixAsLossPayee?: boolean
  contactInfo?: {
    email?: string
    phone?: string
    fax?: string
  }
  automotiveContactInformation?: {
    email?: string
    phone?: string
    fax?: string
  }
  onChange: (...args: any[]) => any
  type: string
}
const CargoCoverageLiability: React.FunctionComponent<ICargoCoverageLiabilityProps> = memo(
  ({
    liabilityAmount,
    expirationDate,
    hasReeferBreakdown,
    hasUnattendedVehicleCoverage,
    hasTheftCoverage,
    isTransfixAsHolder,
    isTransfixAsLossPayee,
    contactInfo = {},
    automotiveContactInformation = {},
    onChange,
    type,
  }) => {
    const { email, fax, phone } = contactInfo || {}
    return (
      <InsuranceDialogSection
        title='Cargo Coverage Liability'
        insuranceType={type}
        contactInfo={contactInfo}
        onChange={onChange}
        rows={[
          [
            {
              type: 'amount',
              key: 'liabilityAmount',
              label: 'Cargo Coverage Liability Amount',
              value: liabilityAmount,
            },
            {
              type: 'expiration',
              key: 'expirationDate',
              label: 'Expiration Date',
              value: expirationDate,
            },
          ],
          [
            {
              type: 'email',
              key: 'email',
              value: email,
              defaultValue: automotiveContactInformation,
            },
            {
              type: 'radio',
              key: 'isTransfixAsHolder',
              label: 'Transfix as holder',
              value: isTransfixAsHolder,
              options: holderOptions,
            },
          ],
          [
            {
              type: 'phone',
              key: 'phone',
              value: phone,
              defaultValue: automotiveContactInformation,
            },
            {
              type: 'radio',
              key: 'isTransfixAsLossPayee',
              label: 'Transfix listed as Loss Payee',
              value: isTransfixAsLossPayee,
              options: lossPayeeOptions,
            },
          ],
          [
            {
              type: 'fax',
              key: 'fax',
              value: fax,
              defaultValue: automotiveContactInformation,
            },
          ],
          [
            {
              type: 'checkbox',
              key: 'hasReeferBreakdown',
              label: 'Reefer Breakdown',
              value: !!hasReeferBreakdown,
            },
          ],
          [
            {
              type: 'checkbox',
              key: 'hasUnattendedVehicleCoverage',
              label: 'Unattended Vehicle Coverage',
              value: !!hasUnattendedVehicleCoverage,
            },
          ],
          [
            {
              type: 'checkbox',
              key: 'hasTheftCoverage',
              label: 'Theft Coverage',
              value: !!hasTheftCoverage,
            },
          ],
        ]}
      />
    )
  }
)

export default CargoCoverageLiability
